// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"50d925b203f866c057e4","354":"6a023fc26fe1313d7bc2","418":"67270ef68417c1c177eb","661":"ed012c39832f40d5babd"}[chunkId] + ".chunk.js";
};